export default __webpack_public_path__ + "assets/resizedmontreal-min.5988a35a.webp";